import { useEffect, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import {
  getAllLocalisations,
  createLocalisation,
  updateLocalisation,
  deleteLocalisation
} from "../../services/localisations";
import type { Localisation } from "../../types/localisation";
import "./Localisations.css";

export default function Localisations() {
  const [localisations, setLocalisations] = useState<Localisation[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedLoc, setSelectedLoc] = useState<Localisation | null>(null);

  useEffect(() => {
    const safeSetArray = <T,>(setter: React.Dispatch<React.SetStateAction<T[]>>) => (data: unknown) => {
      if (Array.isArray(data)) setter(data as T[]);
      else setter([]);
    };

    const fetchData = async () => {
      const data = await getAllLocalisations();
      safeSetArray<Localisation>(setLocalisations)(data);
    };
    fetchData();
  }, []);


  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const localisation = {
      nom: formData.get("nom") as string,
      description: formData.get("description") as string,
    };

    if (selectedLoc) {
      await updateLocalisation(selectedLoc.id, localisation);
    } else {
      await createLocalisation(localisation);
    }

    const data = await getAllLocalisations();
    setLocalisations(data);
    setShowModal(false);
    setSelectedLoc(null);
  };

  const handleDelete = async (id: string) => {
    if (window.confirm("Supprimer cette localisation ?")) {
      await deleteLocalisation(id);
      setLocalisations(localisations.filter((l) => l.id !== id));
    }
  };

  return (
    <div className="localisations">
      <div className="localisations-header">
        <button className="btn-ajout" onClick={() => setShowModal(true)}>
          ➕ Ajouter localisation
        </button>
      </div>

      <table className="localisations-table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {localisations.map((l) => (
            <tr key={l.id}>
              <td>{l.nom}</td>
              <td>{l.description || "-"}</td>
              <td className="actions">
                <FaEdit
                  className="icon-edit"
                  onClick={() => {
                    setSelectedLoc(l);
                    setShowModal(true);
                  }}
                />
                <FaTrash
                  className="icon-trash"
                  onClick={() => handleDelete(l.id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>{selectedLoc ? "Modifier localisation" : "Ajouter localisation"}</h3>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="nom"
                placeholder="Nom"
                defaultValue={selectedLoc?.nom}
                required
              />
              <input
                type="text"
                name="description"
                placeholder="Description"
                defaultValue={selectedLoc?.description || ""}
              />
              <div className="modal-actions">
                <button type="submit">Enregistrer</button>
                <button type="button" onClick={() => setShowModal(false)}>
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
